// Presseartikel für die Startseite.
// Bilder liegen in public/presse/ — der Pfad ist relativ zum deploy-root.
// Neue Einträge einfach am Anfang der Liste einfügen, dann erscheinen sie zuerst.
//
// Felder:
//   src  (pflicht)   Pfad zum Bild, relativ zum public-Ordner
//   text (optional)  Artikeltext; ohne Text wird nur das Bild gezeigt
//   link (optional)  URL — wenn gesetzt, wird die ganze Karte klickbar (öffnet in neuem Tab)

export default [
    {
        src: "presse/artikel1.jpeg",
        text: `Am 25.01.2026 fanden in Braunschweig die Landesmeisterschaften der U21 statt. Nach mehreren Jahren Abstinenz konnten auch wieder zwei Sportler unseres Vereins teilnehmen. Arssen Haumann belegte dabei den ersten Platz in der Gewichtsklasse -90 kg. Wladislaw Solovev belegte den dritten Platz in der Gewichtsklasse bis 81 kg.`,
    },
    {
        src: "presse/artikel2.jpeg",
        text: `Arssen Haumann (-90 kg) belegte den dritten Platz bei der Norddeutschen Meisterschaft der U21. Damit qualifizierte er sich für die Deutsche Meisterschaft.

Auch Wladislaw Solovev (-81) nahm teil, belegte den sechsten Platz und verpasste dadurch knapp die Qualifikation zur Deutschen Meisterschaft.`,
    },
    {
        src: "presse/artikel3.jpeg",
        text: `Erfolgreiche Gürtelprüfungen für unsere Jüngsten!

Vor den Frühlingsferien fand unsere nächste Gürtelprüfung statt. 12 unserer Kinder haben bestanden und können nun endlich den farbigen Gurt tragen.

Wir wünschen allen schöne Frühlingsferien und frohe Ostern!`,
    },
];
